export default "__VITE_ASSET__c03188dc__"